import { fundApi } from './fundApi';
export { fundApi };
export default fundApi;